import type { ChangelogItemsData } from '@entities/changelog'
import type { ApiResponse } from '@shared/api'

import { useChangelogStore } from '@entities/changelog'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

export const useChangelogItemsApi = async (actionId: number): Promise<void> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useChangelogStore()

  const url = useAdminRoutes('admin.changelog.items', { action_id: actionId })

  store.setItems([])
  store.setItemsLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return
    }

    const { data } = await $axios.get<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return
    }

    const payload: ChangelogItemsData | null = data.data || null
    store.setItems(payload?.items ?? [])
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
  } finally {
    store.setItemsLoading(false)
  }
}
